import React, { useContext } from 'react'

import styled from 'styled-components/macro'
import { faFilePdf, faLink } from '@fortawesome/pro-light-svg-icons'
import { useTranslation } from 'react-i18next'

import { AuthenticationContext } from 'contexts'

/* Import utilities here */

/* Import components here */
import { ButtonLink } from '../../components'

const Paragraph = styled.p`
  margin-bottom: 1rem;
`

function BusinessDocumentPartial(): JSX.Element {
  const { t } = useTranslation('common')
  return (
    <>
      <h3>{t('documents.business.title')}</h3>
      <div className="form-group">
        <h4 className="label">{t('vehicles')}</h4>
        <ButtonLink
          className="fullWidth"
          icon={faFilePdf}
          target="_blank"
          to={{
            pathname: 'https://opus.se/wp-content/uploads/2025/03/Fullmakt-registreringsanmalan-160119.pdf',
          }}
        >
          Fullmakt reg.anmälan
        </ButtonLink>
        <ButtonLink
          className="fullWidth"
          icon={faFilePdf}
          target="_blank"
          to={{
            pathname: 'https://opus.se/wp-content/uploads/2025/03/Besiktningsprotokollets-baksida-231005.pdf',
          }}
        >
          Protokollets baksida
        </ButtonLink>
        <ButtonLink
          className="fullWidth"
          icon={faFilePdf}
          target="_blank"
          to={{
            pathname: 'https://opus.se/wp-content/uploads/2025/03/Redogorelse-utforda-andringar-1601.pdf',
          }}
        >
          Redogörelse ändringar
        </ButtonLink>
        <ButtonLink
          className="fullWidth"
          icon={faFilePdf}
          target="_blank"
          to={{
            pathname:
              'https://opus.se/wp-content/uploads/2025/03/Informationsblad-och-blankett-for-skadat-eller-saknat-primart-chassinummer.pdf',
          }}
        >
          Fordonets identitet
        </ButtonLink>
      </div>
      <div className="form-group">
        <h4 className="label">{t('finances')}</h4>
        <ButtonLink
          className="fullWidth"
          icon={faLink}
          target="_blank"
          to={{
            pathname: 'https://opus.se/wp-content/uploads/2025/03/Ansokan-fakturering-160901.pdf',
          }}
        >
          Ansökan om fakturering
        </ButtonLink>
        <ButtonLink
          className="fullWidth"
          icon={faFilePdf}
          target="_blank"
          to={{
            pathname:
              'https://opus.se/wp-content/uploads/2025/03/Autogiroanmalan-medgivande-till-bankgironummer-150420.pdf',
          }}
        >
          Autogiro-medgivande
        </ButtonLink>
      </div>
      <div className="form-group">
        <h4 className="label">{t('certificates')}</h4>
        <ButtonLink
          className="fullWidth"
          icon={faFilePdf}
          target="_blank"
          to={{
            pathname: 'https://opus.se/wp-content/uploads/2025/03/Rengorings-och-Tomningsintyg-2025.1.pdf',
          }}
        >
          Rengöringsintyg
        </ButtonLink>
      </div>
    </>
  )
}

function PrivateDocumentPartial() {
  const { t } = useTranslation('common')
  return (
    <>
      <h3>{t('documents.private.title')}</h3>
      <Paragraph>{t('documents.private.text')}</Paragraph>
      <div className="form-group">
        <ButtonLink
          className="fullWidth"
          icon={faLink}
          target="_blank"
          to={{
            pathname: `https://opus.se/besiktningar/blanketter?qs=blanketter`,
          }}
        >
          {t('forms')}
        </ButtonLink>
      </div>
    </>
  )
}

// Component
const DocumentsAsidePartial: React.FunctionComponent = () => {
  const authContext = useContext(AuthenticationContext)
  if (authContext.customerType === 'private') {
    return <PrivateDocumentPartial />
  }
  return <BusinessDocumentPartial />
}

/** @component */
export default DocumentsAsidePartial
